import { gql } from "apollo-boost";


export const GET_STUDENT_ENROLL_BY_CURRENT_USER = gql`
  query getStudentEnrollsByCurrentUser{
    getStudentEnrollsByCurrentUser {
      id periodCode studentCode enrollDate totalCredit totalDropCredit
      studentEnrollDetails {
        id sectionNo subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
        studentUnitLearns {
          id unitSeq totalVdoLength totalLearnTime learnPercent
          courseOutlineUnit { id countLearnPercent
            mustLearnPrevious previousPercentRequireBeforeLearn }
        }
        subject {
          id
          code
          nameLocal
        }
        teacher {
          id
          prefix {
            nameLocal
          }
          firstNameLocal
          lastNameLocal
          telephone
          email
          availableTime
          code
          picturePath
        }
        classSection {
          id sectionNo learnSpanNo
          vdoSet {
            id totalVdoLength
            vdoSetUnits {
              id totalVdoLength
              courseOutlineUnit { id countLearnPercent
                mustLearnPrevious previousPercentRequireBeforeLearn }
            }
          }
        }
      }
    }
  }
`;

export const GET_STUDENT_ENROLL_BYID = gql`
  query getStudentEnroll($id: ID!) {
    getStudentEnroll(
      id: $id
    ) {
      id
      enrollNo
      academicPeriod {
        id
      }
      periodCode
      student {
        id
      }
      studentCode
      enrollDate
      totalCredit
      totalDropCredit
      source
    }
  }
`;

export const GET_STUDENTENROLL_LIST = gql`
  query getStudentEnrolls {
    getStudentEnrolls {
      id
      enrollNo
      academicPeriod {
        id
      }
      periodCode
      student {
        id
        prefix { id nameLocal nameShortLocal nameEng nameShortEng }
        firstNameLocal
        lastNameLocal
      }
      studentCode
      studentUnitLearn {
        id
        name
      }
      enrollDate
      totalCredit
      totalDropCredit
      source
    }
  }
`;

export const GET_STUDENTENROLL_BYFILTER = gql`
  query getStudentEnrollsByFilter(
    $courseOutlineRegistratonFilterInput: StudentEnrollFilterInput
  ) {
    getStudentEnrollsByFilter(
      courseOutlineRegistrationFilterInput: $courseOutlineRegistrationFilterInput
    ) {
      id
    }
  }
`;

export const ADD_STUDENTENROLL = gql`
  mutation addStudentEnroll(
    $courseOutlineRegistrationInput: [StudentEnrollInput!]
  ) {
    addStudentEnroll (
      courseOutlineRegistrationInput: $courseOutlineRegistrationInput
    )
      {
        id
        academicPeriod{
          id periodCode year semester
        }
        periodCode
        courseOutline{
          id
        }
        degree{
          id code nameLocal nameEng
        }
        subjectGroup{
          id code nameLocal nameEng
        }
        subject{
          id code nameLocal nameEng
        }
        subjectCode
        subjectName
        teacher{
          id code firstNameLocal lastNameLocal
          prefix{
            id nameLocal nameEng nameShortLocal nameShortEng
          }
        }
        teacherCode
        classSections{
          id
        }
      }
  }
`;

export const UPDATE_STUDENTENROLL = gql`
  mutation updateStudentEnroll(
    $id: ID!,
    $courseOutlineRegistrationInput: StudentEnrollInput!
  ) {
    addStudentEnroll (
      id: $id
      courseOutlineRegistrationInput: $courseOutlineRegistrationInput
    ) {
      id
    }
  }
`;

export const DELETE_STUDENTENROLL = gql`
  mutation deleteStudentEnroll(
    $id: ID!
  ) {
    deleteStudentEnroll (
      id: $id
    ) {
      id
    }
  }
`;

export const UPLOAD_STUDENTENROLL_SPREADSHEET = gql`
  mutation uploadStudentEnrollSpreadsheet(
    $file: Upload!
  ) {
    uploadStudentEnrollSpreadsheet (
      file: $file
    ) {
      filename
    }
  }
`;
